import { TemplateStage5Form } from './TemplateStage5Form';

export default TemplateStage5Form;